// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components----Layout-module---root---iEBEl","body":"src-components----Layout-module---body---2kj0V"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout.module.scss
// module id = ./src/components/Layout.module.scss
// module chunks = 114276838955818